import React from 'react';
import {connect} from "react-redux";
import {Avatar, Paper, Subheader} from "material-ui";
import gravatar from 'gravatar';
import Loading from "../../../components/common/Loading/Loading";
import AdminPasswordForm from "../../../components/admin/AdminPasswordForm/AdminPasswordForm";
import styles from './EditPasswordPage.css';
import style from '../../../styles/styles';
import {editAdmin} from '../../../store/auth/actions';
import withTranslation from "../../../hoc/withTranslation";
import {PROFILE_PAGE} from "../../../constants/routes";

export class EditPasswordPage extends React.Component {

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            this.props.history.push(PROFILE_PAGE);
        }
    }

    handleFormSubmit = async (formProps) => {
       await this.props.editAdmin(formProps);
    };

    render() {
        if (this.props.loading || !this.props.user || this.props.sending) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('account_page.account')} / {this.props.t('account_page.change_password')}</h3>
                    <Avatar src={gravatar.url(this.props.user.email)}
                            size={75}
                            style={styles.avatar}/>
                    <Paper style={styles.editBox}>
                        <Subheader style={style.subHeader}>{this.props.t('account_page.change_password')}</Subheader>
                        <div style={style.paper}>
                            <AdminPasswordForm onSubmit={this.handleFormSubmit} initialValues={this.props.initialValue} submitting={this.props.sending}/>
                        </div>
                        <div style={style.clear}/>
                    </Paper>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.auth.loading,
        sending: state.auth.sending,
        authenticated: state.auth.authenticated,
        user: state.auth.content,
        initialValue: state.auth.content
    }
}

export default connect(mapStateToProps, {editAdmin})(withTranslation(EditPasswordPage));



// WEBPACK FOOTER //
// src/containers/common/EditPasswordPage/EditPasswordPage.js